import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import { Config } from '../config';
import {  IGroupClassification, ISectionHeader, ICOAClassification } from '../models/classification';
import { CommonService } from '../../shared/services/common.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { tap } from 'rxjs/operators/tap';
import { toODataString } from '@progress/kendo-data-query';
import { IFiscalYear } from '../models/common';


@Injectable({
    providedIn: 'root'
})
export class ClassificationService {
    baseUrl: string = Config.ROOT_URL;
    CommonUrl = '/api/Common';
    ClassificationUrl = '/api/Classification';

    constructor(private dataService: CommonService, private http: HttpClient) { }

    /* varLI: ICOAClassification[] = [];
    public isSubmit: BehaviorSubject<ICOAClassification[]> = new BehaviorSubject<ICOAClassification[]>(this.varLI);
    */

    getFiscalYears(): Observable<IFiscalYear[]> {
        const htheaders = new HttpHeaders();
        return this.http.get<IFiscalYear[]>(this.baseUrl + this.CommonUrl + '/GetFiscalYear', { headers: htheaders })
            .pipe(
                map(results => {
                    return results;
                }),
                catchError(this.dataService.handleError)
            );
    }

    getGroupClassifications(): Observable<IGroupClassification[]> {

        return this.http.get<IGroupClassification[]>(this.baseUrl +
            this.ClassificationUrl + '/GetGroupClassification', { headers: Config.httpHeaders })
            .pipe(
                map(results => {
                    return results;
                }),
                catchError(this.dataService.handleError)
            );
    }
    public getSections(groupHeaderID: number): Observable<ISectionHeader[]> {

        return this.http.get<ISectionHeader[]>(this.baseUrl + this.ClassificationUrl + '/GetSectionHeader' +
            '/' + groupHeaderID, { headers: Config.httpHeaders })
            .pipe(
                map(results => {
                    return results;
                }),
                catchError(this.dataService.handleError)
            );
    }
    getCodeSearchDetails(code: string, name: string , groupHeaderID: number, checkPublish: boolean): Observable<ICOAClassification[]> {

        return this.http.get<ICOAClassification[]>(this.baseUrl + this.ClassificationUrl +
            '/GetCodeSearchDetails/' + code + '/' + name + '/' + groupHeaderID + '/' + checkPublish 
           , { headers: Config.httpHeaders })
            .pipe(
                map(results => {
                    return results;
                }),
                catchError(this.dataService.handleError)
            );
    }

    // tslint:disable-next-line:max-line-length
    getGridDetails(groupHeaderID: number, sectionHedaerID: number, fiscalYearConfigID: number, checkPublish: boolean): Observable<ICOAClassification[]> {

        return this.http.get<ICOAClassification[]>(this.baseUrl + this.ClassificationUrl +
            '/GetClassificationGridDetails' + '/' + groupHeaderID + '/' + sectionHedaerID +
            '/' + fiscalYearConfigID + '/' + checkPublish , { headers: Config.httpHeaders })
            .pipe(
                map(results => {
                    return results;
                }),
                catchError(this.dataService.handleError)
            );
    }
    terminate(fiscalYear: number, model: ICOAClassification): any {

        return this.http.post<ICOAClassification[]>(this.baseUrl + this.ClassificationUrl +
            '/TerminateCode' + '/' + fiscalYear, model, { headers: Config.httpHeaders })
            .pipe(
                map(results => {
                    return results;
                }),
                catchError(this.dataService.handleError)
            );
    }
    delete(model: ICOAClassification): any {

        return this.http.post<ICOAClassification[]>(this.baseUrl + this.ClassificationUrl +
            '/DeleteCode', model, { headers: Config.httpHeaders })
            .pipe(
                map(results => {
                    return results;
                }),
                catchError(this.dataService.handleError)
            );
    }
    update(model: ICOAClassification, fiscalYearConfigID: number) {
        return this.http.post<ICOAClassification[]>(this.baseUrl +
            this.ClassificationUrl + '/UpdateLineItem/' + fiscalYearConfigID, model, { headers: Config.httpHeaders })
            .pipe(
                map(results => {
                    return results;
                }),
                catchError(this.dataService.handleError)
            );
    }
    Add(fiscalYear: number, model: ICOAClassification) {
        return this.http.post<ICOAClassification[]>(this.baseUrl + this.ClassificationUrl +
            '/AddLineItem' + '/' + fiscalYear, model, { headers: Config.httpHeaders })
            .pipe(
                map(results => {
                    return results;
                }),
                catchError(this.dataService.handleError)
            );
    }
    checkRelation(model: ICOAClassification): any {
        return this.http.post<ICOAClassification[]>(this.baseUrl + this.ClassificationUrl +
            '/CheckRelation', model, { headers: Config.httpHeaders })
            .pipe(
                map(results => {
                    return results;
                }),
                catchError(this.dataService.handleError)
            );
    }

}

